/**
{
  'site': {
    'id': '',

    'store': {
      'type': 'drupal',
      'settings': {
        'endpoint': ''
      }
    },

    'settings': {
      'local-storage': true,
      'title': 'Incipere'
    }
  },

  'modules': {
    'captcha': {
      'recaptcha-key': ''
    },
    'webform': {
      3: {
        'fullname': 1,
        'phone': 2,
        'email': 3,
        'message': 4,
        'type': 5
      }
    },
    'signup': {
      'recaptchaSiteKey": '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
      'recaptchaSecretKey": '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe',
      'googleApiKey": 'AIzaSyBk5BE5t1Fw6SNsimmhZyV7tFfJFiX9Jdk'
    }
  },

  'services': {
    'fusws': {
      'website': {
        'endpoint': 'https://fusws.svc.devops.aspedia.net',
        'id': 'incipere-development-website-base'
      },

      'crm-resource': {
        'endpoint': 'https://fusws.svc.devops.aspedia.net',
        'id': 'incipere-development-crm-resource'
      }
    },

    'thesaurum': {
      'endpoint': 'https://thesaurum.svc.devops.aspedia.net'
    },

    'raven': {
      'endpoint': ''
    }
  },
  'features': {
    'news': true,
    'events': false,
    'positions-wanted': false,
    'positions-vacant': false,
    'shop': false,
    'ecommerce': false,
    'resources': false,
    'faq': true,
    'sponsors': false,
    'search': false,
    'signup-module': true
  }
}
 */

const Registry = function(config, funcs = {}) {
  this.__config = config || {}

  this.isUV = funcs.isUV || function() {
    return this.__getKey([
      'site',
      'uv'
    ])
  }

  this.getSiteId = funcs.getSiteId || function() {
    return this.__getKey([
      'site',
      'id'
    ])
  }

  this.getSiteSetting = funcs.getSiteSetting || function(setting, noValue = null) {
    return this.__getKey([
      'site',
      'settings',
      setting
    ], noValue)
  }

  this.getStoreType = funcs.getStoreType || function() {
    return this.__getKey([
      'site',
      'store',
      'type'
    ])
  }

  this.getStoreEndpoint = funcs.getStoreEndpoint || function() {
    return this.__getKey([
      'site',
      'store',
      'settings',
      'endpoint'
    ])
  }

  this.getModuleSetting = funcs.getModuleSetting || function(module, setting = false, noValue = null) {
    return this.__spliceGetKey([
      'modules',
      module
    ], setting, 2, noValue)
  }

  this.getFeature = funcs.getFeature || function(feature, noValue = false) {
    return this.__getKey([
      'features',
      feature
    ], noValue)
  }

  this.getServiceEndpoint = funcs.getServiceEndpoint || function(service, item = false) {
    return this.__spliceGetKey([
      'services',
      service,
      'endpoint'
    ], item, 2)
  }

  this.getServiceId = funcs.getServiceId || function(service, item = false) {
    return this.__spliceGetKey([
      'services',
      service,
      'id'
    ], item, 2)
  }

  this.getServiceSetting = funcs.getServiceSetting || function(service, setting = false, noValue = null) {
    return this.__spliceGetKey([
      'services',
      service,
    ], setting, 2, noValue)
  }

  this.__spliceGetKey = function(keys, item, position, noValue = null) {
    if (item) keys.splice(position, 0, item)
    return this.__getKey(keys, noValue)
  }

  this.__getKey = function(keys, fallback = '') {
    return keys.reduce((acc, curr) => acc && Object.prototype.hasOwnProperty.call(acc, curr) ? acc[curr] : fallback, this.__config)
  }
}

export {
  Registry
}
